import { ModelBase } from '@framework/models/base/base.model';

export class GetAppSettingOutputApiModel extends ModelBase {
    public social_domains: string[];
    public sso_domains: any;
    constructor(init?: Partial<GetAppSettingOutputApiModel>) {
        super(init);
        Object.assign(this,init);
    }
}